(function() {
  'use strict';

  angular.module('app').factory('SettingsService', SettingsService);

  SettingsService.$inject = ['$rootScope', 'API', '$filter'];

  function SettingsService($rootScope, API, $filter) {
    var service = {};

    var _req_gc = ['COUNTRIES', 'TIMEZONES', 'NEWS_CATEGORIES'];

    initVars();

    function initVars() {
      for (var i in _req_gc)
        $rootScope[_req_gc[i]] = [];
    }

    $rootScope.$on('user-login', function() {
      initVars();
    });

    $rootScope.$on('user-register', function() {
      initVars();
    });

    $rootScope.$on('user-logout', function() {
      for (var i in _req_gc)
        $rootScope[_req_gc[i]] = null;
    });

    service.CurrentCountry = function(callback) {
      API.get('/settings/countries/current', function(success, data) {
        callback(success, data);
      });
    };

    service.Countries = function(callback) {
      var lang = $rootScope.LANG;

      if (!$rootScope.COUNTRIES)
        $rootScope.COUNTRIES = [];

      if ($rootScope.COUNTRIES[lang]) {
        callback(true, $rootScope.COUNTRIES[lang]);
      } else {
        API.get('/settings/countries', function(success, data) {
          if (success) {
            var orderBy = $filter('orderBy');
            data.forEach(function(item) {
              item.id = item.code;
            });
            $rootScope.COUNTRIES[lang] = orderBy(data, 'title', false);
          }
          callback(success, data);
        });
      }
    };

    service.Timezones = function(callback) {
      var lang = $rootScope.LANG;

      if (!$rootScope.TIMEZONES)
        $rootScope.TIMEZONES = {};

      if ($rootScope.TIMEZONES[lang]) {
        callback(true, $rootScope.TIMEZONES[lang]);
      } else {
        API.get('/settings/timezones', function(success, data) {
          if (success) {
            var orderBy = $filter('orderBy');
            data = orderBy(data, 'offset', false);
            $rootScope.TIMEZONES[lang] = data;
          }
          callback(success, data);
        });
      }
    };

    service.NewsCategories = function(callback) {
      var lang = $rootScope.LANG;

      if (!$rootScope.NEWS_CATEGORIES)
        $rootScope.NEWS_CATEGORIES = [];

      if ($rootScope.NEWS_CATEGORIES[lang]) {
        callback(true, $rootScope.NEWS_CATEGORIES[lang]);
      } else {
        API.get('/settings/news_categories', function(success, data) {
          if (success) {
            $rootScope.NEWS_CATEGORIES[lang] = data;
          }
          callback(success, data);
        });
      }
    };

    service.GetLegalLinks = function(callback) {
      var lang = $rootScope.LANG;

      if (!$rootScope.SERVICE_LINKS && !$rootScope.SERVICE_LINKS.terms_of_service_url && !$rootScope.SERVICE_LINKS.privacy_policy_url)
        $rootScope.SERVICE_LINKS = {};

      if ($rootScope.SERVICE_LINKS[lang] && $rootScope.SERVICE_LINKS[lang].terms_of_service_url &&
          $rootScope.SERVICE_LINKS[lang].privacy_policy_url) {
        callback(true, $rootScope.SERVICE_LINKS[lang]);
      } else {
        API.get('/settings/platform/params', function(success, data) {
          if (success) {
            $rootScope.SERVICE_LINKS[lang] = data;
          }
          callback(success, data);
        });
      }
    };

    service.GetPlatformParams = function(callback) {
      if ($rootScope.PLATFORM_PARAMS) {
        callback(true, $rootScope.PLATFORM_PARAMS);
      } else {
        API.get('/settings/platform/params', function(success, data) {
          if (success) {
            $rootScope.PLATFORM_PARAMS = data;
          }
          callback(success, data);
        });
      }
    };

    service.GetPlatformSupportedLanguages = function(callback) {
      service.GetPlatformParams(function(success, data) {
        if (success) {
          callback(true, data.supported_languages || null);
        } else {
          callback(false, null);
        }
      });
    };

    service.GetPlatformModulesBusiness = function(callback) {
      API.get('/settings/modules/business', function(success, data) {
        callback(success, data);
      });
    };

    service.GetPlatformModulesBusinessPreferences = function(callback) {
      API.get('/settings/modules/business/preferences', function(success, data) {
        callback(success, data);
      });
    };

    return service;
  }

})();
